import { render, staticRenderFns } from "./culture-select.vue?vue&type=template&id=37a47056"
import script from "./culture-select.vue?vue&type=script&lang=js"
export * from "./culture-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports